import {createApp} from 'vue'
import App from './App.vue'
// Default Konfiguration
import defaults from './config.js'
import {getElementConfig} from '@/composable/getElementConfig'

// Über die Element-Attribute von glasses-main-app können ebenfalls Konfigurationen definiert werden.
const attributes = getElementConfig()
//Defaults aus config.js werden von Konfigurationen aus Elementattributen überschrieben
const options = { ...defaults, ...attributes}

// Create APP
const vue = createApp(App, {
    data() {
    },
    config: options
}, options)
vue.mount('#glasses-main-app')

